/* tslint:disable */
import {
  StockWarehouseLocation,
  Company
} from '../index';

declare var Object: any;
export interface ManufacturingWorkLineInterface {
  "id"?: number;
  "name"?: string;
  "reference"?: string;
  "warehouse_location_id"?: number;
  "company_id"?: number;
  warehouseLocation?: StockWarehouseLocation;
  company?: Company;
}

export class ManufacturingWorkLine implements ManufacturingWorkLineInterface {
  "id": number;
  "name": string;
  "reference": string;
  "warehouse_location_id": number;
  "company_id": number;
  warehouseLocation: StockWarehouseLocation;
  company: Company;
  constructor(data?: ManufacturingWorkLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ManufacturingWorkLine`.
   */
  public static getModelName() {
    return "ManufacturingWorkLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ManufacturingWorkLine for dynamic purposes.
  **/
  public static factory(data: ManufacturingWorkLineInterface): ManufacturingWorkLine{
    return new ManufacturingWorkLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ManufacturingWorkLine',
      plural: 'ManufacturingWorkLines',
      path: 'ManufacturingWorkLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "reference": {
          name: 'reference',
          type: 'string'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
      },
      relations: {
        warehouseLocation: {
          name: 'warehouseLocation',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ManufacturingWorkLine.ts